<template>
    <!-- 教学管理 -->
    <div id="paynow">
        <el-tabs type="card">
            <el-tab-pane label="确认付款">
                <div class="payMoney">
                    支付：
                    <span>￥{{ RecordData.order.amount }}</span>
                </div>
                <el-button
                    style="
                        float: right;
                        position: relative;
                        bottom: -1px;
                        background: #fff;
                        z-index: 9;
                    "
                    plain
                    @click="detailshow"
                >订单详情 <i class="el-icon-arrow-down" /></el-button>
                <el-table
                    :data="RecordData.orderClassStudents"
                    ref="CourseData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    v-loading="loading"
                    v-if="show"
                    element-loading-text="数据加载中，请稍等..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <el-table-column
                        prop="className"
                        label="班级"
                        fixed="left"
                        show-overflow-tooltip
                        min-width="50"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="fee"
                        label="学费/元"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="materialCost"
                        label="材料费/元"
                        show-overflow-tooltip
                        v-if="ismast"
                    ></el-table-column>
                    <el-table-column
                        prop="allClassFee"
                        label="报名费/元"
                        show-overflow-tooltip
                        v-if="isbm"
                    ></el-table-column>
                    <el-table-column
                        prop="ageRemissionMoney"
                        label="年龄折扣/元"
                        show-overflow-tooltip
                        v-if="agediscount"
                    >
                        <template slot-scope="scope">
                            <span v-if="!scope.row.ageRemissionMoney"> 0 </span>
                            <span v-else>
                                {{ scope.row.ageRemissionMoney }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="identityRemission"
                        label="特殊身份减免/元"
                        show-overflow-tooltip
                        v-if="isspecial"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="subtotal"
                        label="小计/元"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="reductionMoney"
                        label="学期优惠/元"
                        show-overflow-tooltip
                        v-if="reductionFlag"
                    ></el-table-column>
                </el-table>
                <div
                    class="table-footer confirm-footer"
                    v-if="show"
                >
                    <!-- <div class="f-footer">
                      <div v-if="RecordData.order.preferentialMoney">
                        <span>学期报名优惠:￥</span>
                        <span>{{RecordData.order.preferentialMoney}}</span></div>
                  </div> -->
                </div>
                <div class="paytype">
                    <div class="pay-title">
                        请选择支付方式（提示：您的订单还没有付款，支付成功后订单才能生效）
                    </div>
                    <div class="item-m">
                        <!-- <div class="pay-item">
                            <img
                                src="@/assets/images/icon/z.png"
                                alt=""
                                style="margin-left: 30px; width: 40px"
                            />
                            <div style="width: 90px">
                                <div>支付宝</div>
                                <div>ALIPAY</div>
                            </div>
                        </div> -->

                        <div
                            class="pay-item"
                            @click="choosetype(1)"
                            v-if="payButtonAuth.includes(6)"
                        >
                            <img
                                src="@/assets/images/icon/w.png"
                                alt=""
                            />
                            <div style="width: 120px">
                                <div>微信支付</div>
                                <div>WeWchat Pay</div>
                            </div>
                        </div>
                        <div
                            class="pay-item"
                            @click="choosetype(31)"
                            v-if="payButtonAuth.includes(31)"
                        >
                            <div>&nbsp;&nbsp;博思支付&nbsp;&nbsp;</div>
                        </div>
                        <div
                            class="pay-item"
                            @click="choosetype(41)"
                            v-if="payButtonAuth.includes(41)"
                        >
                            <div>&nbsp;&nbsp;非税支付&nbsp;&nbsp;</div>
                        </div>
                    </div>
                    <!-- <div v-for="(item,index) in paydata" :key="index" @click="choosetype(index)">
                    <div>
                        <img :src="item.src" alt="">
                          {{item.name}}
                    </div>
                    <img src="@/assets/images/icon/w-c.png" alt="" v-if="item.selected" class="c-circle">
                    <img src="@/assets/images/icon/w-s.png" alt="" v-else class="c-circle">
                 </div>    -->
                </div>
                <div class="remark">
                    订单有误，想重新选择缴费班级，<el-button
                        type="text"
                        @click="cancelorder"
                    >
                        取消订单</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="60%"
            @close="handleCloses"
        >
            <div class="pay-content">
                <div class="pay-left">
                    <div>
                        订单将在{{ minutes }}分钟{{
                            seconds
                        }}秒后关闭，请及时交款
                    </div>
                    <div
                        id="qrcode"
                        class="qrcode"
                        style="width: 160px; height: 160px"
                    ></div>
                    <div>请用微信扫一扫完成支付</div>
                </div>
                <div
                    class="pay-right"
                    v-if="dialogVisible"
                >
                    <div>付款金额：</div>
                    <div>{{ RecordData.order.amount }}</div>
                    <div>
                        商品名称:<span>{{
                                RecordData.orderClassStudents[0].className
                            }}等</span>
                    </div>
                    <!-- <div>收款方：<span>span</span></div> -->
                    <div>
                        下单时间:<span>{{ RecordData.order.gmtCreate }}</span>
                    </div>
                    <div>
                        订单号:<span>{{ RecordData.order.orderNo }}</span>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import w from "@/assets/images/icon/w.png";
import z from "@/assets/images/icon/z.png";
import QRCode from "qrcode2";
export default {
    name: "paynow",

    data () {
        return {
            show: false,
            isspecial: false,
            transfer: false,
            agediscount: false,
            ismast: false,
            isbm: false,
            reductionFlag: false,
            ercode: "",
            title: "微信支付| 收银台",
            dialogVisible: false,
            tabindex: "0",
            minutes: 5,
            seconds: 0,
            timeer: "",
            timer: "",
            payform: {
                orderId: "",
                type: 2,
            },
            totalfee: "",
            paydata: [
                {
                    name: "微信支付",
                    src: w,
                    selected: false,
                },
                {
                    name: "支付宝",
                    src: z,
                    selected: false,
                },
            ],
            RecordData: {
                orderClassStudents: "",
                order: "",
            },

            payButtonAuth: []
        };
    },
    async created () {
        this.$global.activeMenu = "2-4"; //不激活左侧
        this.loadPayButton();
    },
    mounted () {
        this.reductionFlag = false;
        if (this.$route.params.orderdata) {
            this.RecordData = JSON.parse(this.$route.params.orderdata);
        } else if (this.$route.params.orderdatas) {
            let data = JSON.parse(this.$route.params.orderdatas);
            this.RecordData.orderClassStudents = data.csData;
            this.RecordData.order = data.order;
        }
        let me = this;
        this.RecordData.orderClassStudents.forEach(function (item, index) {
            if (item.zkAge && item.ageRemissionMoney) {
                me.agediscount = true;
            }
            if (item.materialCost) {
                me.ismast = true;
            }
            if (item.allClassFee) {
                me.isbm = true;
            }
            if (item.identityRemission) {
                me.isspecial = true;
            }
            if (item.traFee) {
                me.transfer = true;
            }
            if (item.susFee) {
                me.isxx = true;
            }
            if (item.reductionFlag) {
                me.reductionFlag = true;
            }
        });
    },
    methods: {
        num: function (n) {
            return n < 10 ? "0" + n : "" + n;
        },
        add: function () {
            var _this = this;
            _this.timeer = window.setInterval(function () {
                if (_this.seconds === 0 && _this.minutes !== 0) {
                    _this.hastime = true;
                    _this.seconds = 59;
                    _this.minutes -= 1;
                } else if (_this.minutes === 0 && _this.seconds === 0) {
                    _this.seconds = 0;
                    window.clearInterval(_this.timeer);

                    _this.minutes = 5;
                    _this.dialogVisible = false;

                    _this.payform = {
                        orderId: "",
                        type: 2,
                    };
                    let data = _this.paydata;
                    data.forEach(function (item, index) {
                        item.selected = false;
                    });
                } else {
                    _this.seconds -= 1;
                }
            }, 1000);
        },
        handleCloses () {
            this.minutes = 5;
            this.seconds = 0;
            window.clearInterval(this.timer);
            window.clearInterval(this.timeer);
        },
        choosetype (index) {
            // let data=this.paydata;
            // data.forEach(function(item,index){
            //     item.selected=false;
            // })
            // data[index].selected=!data[index].selected;
            this.payform.orderId = this.RecordData.order.id;
            if (index == 1) {
                this.payform.type = 2;
                this.paynow();
                (this.title = "微信支付| 收银台"), (this.dialogVisible = true);
            } else if ([31, 41].includes(index)) {
                this.payform.deviceType = "pc";
                this.payform.type = index;
                this.paynow();
            }
        },
        detailshow () {
            let statu = this.show;
            this.show = !statu;
        },
        async paynow () {
            let me = this,
                param = me.payform;
            let res = await me.$userService.payByOrder(param);
            if (res && res["success"]) {
                if (me.payform.type == 31) {
                    let route = this.$router.resolve({
                        name: "Bosi",
                    });
                    sessionStorage.setItem(
                        "bosiExtraInfo",
                        res.content.extraInfo
                    );
                    window.open(route.href, "_blank");
                    this.$confirm(
                        "付款完成前请不要关闭此窗口，完成付款后点击按钮关闭",
                        "请您在新打开的页面上完成付款",
                        {
                            confirmButtonText: "确定",
                            showCancelButton: false,
                            closeOnClickModal: false,
                            type: "warning",
                        }
                    )
                        .then(() => {
                            let res = me.$team.queryOrderDetail({
                                orderId: me.payform.orderId,
                            });
                            if (res && res["success"]) {
                                if (res.content.payStatus == "2") {
                                    me.$router.push({ path: "/Order" });
                                }
                            }
                        })
                        .catch(() => { });
                    return false;
                }
                if (me.payform.type == "41") {
                    let loadFeiShuiHtmlRes = await me.$userService.loadFeiShuiHtml(res.content);
                    let route = this.$router.resolve({
                        name: "nonTax",
                    });
                    sessionStorage.setItem(
                        "nonTaxInfo",
                        loadFeiShuiHtmlRes.data
                    );
                    window.open(route.href, "_blank");
                    this.$confirm(
                        "付款完成前请不要关闭此窗口，完成付款后点击按钮关闭",
                        "请您在新打开的页面上完成付款",
                        {
                            confirmButtonText: "确定",
                            showCancelButton: false,
                            closeOnClickModal: false,
                            type: "warning",
                        }
                    )
                        .then(() => {
                            let res = me.$team.queryOrderDetail({
                                orderId: me.payform.orderId,
                            });
                            if (res && res["success"]) {
                                if (res.content.payStatus == "2") {
                                    me.$router.push({ path: "/Order" });
                                }
                            }
                        })
                        .catch(() => { });
                    return false;
                }
                if (res.content.requestResult) {
                    document.getElementById("qrcode").innerHTML = "";
                    let qrcode = new QRCode(document.getElementById("qrcode"), {
                        text: res.content.codeUrl,
                        width: 160,
                        height: 160,
                        correctLevel: QRCode.CorrectLevel.H, // 二维码容错级别 H M L
                    });
                    me.add();
                    me.orderstatus(me.RecordData.order.id);
                    me.ercode = qrcode;
                } else {
                    me.$message({
                        message: res.content.msg,
                        type: "warning",
                    });
                }
            }
        },
        //订单状态改变
        async orderstatus (orderId) {
            let me = this;
            this.timer = setInterval(async function () {
                let param = {
                    orderId: "",
                };
                param.orderId = orderId;
                let res = await me.$team.queryOrderDetail(param);
                if (res && res["success"]) {
                    if (res.content.payStatus == "2") {
                        me.dialogVisible = false;
                        clearInterval(me.timer);
                        window.clearInterval(me.timer);
                        me.$alert("付款成功", "提示", {
                            confirmButtonText: "确定",
                            callback: (action) => {
                                me.$router.replace({
                                    name: "Order",
                                    query: { param: "1" },
                                });
                            },
                        });
                    }
                }
            }, 2000);
        },
        cancelorder () {
            let me = this;
            this.$confirm("您是否确定取消订单?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    me.cancels();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        async cancels () {
            let me = this;
            let param = {
                orderId: "",
            };
            param.orderId = this.RecordData.order.id;
            let res = await me.$userService.cancelOrder(param);
            if (res && res["success"]) {
                this.$message({
                    type: "info",
                    message: "已取消",
                });
                me.$router.replace({ name: "Order" });
            }
        },
        setIndex (e) {
            let me = this;
            me.tabindex = e.index;
        },
        async loadPayButton () {
            let res = await this.$team.loadPayButton();
            if (res && res.success) {
                this.payButtonAuth = eval("(" + res.content + ")");
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#paynow {
    .pay-content {
        display: flex;
        padding: 30px;
        .pay-right {
            width: 50%;
            div {
                width: 70%;
                margin: 10px auto;
                color: #999;
                font-size: 16px;
                span {
                    color: #333;
                }
            }
            div:nth-child(2) {
                font-size: 24px;
                font-weight: bold;
                padding: 0 10px;
                box-sizing: border-box;
                color: #333;
            }
        }
        .pay-left {
            border-right: 1px dashed #999;
            width: 50%;
            div {
                font-size: 16px;
                color: #333;
                margin: 10px auto;
                text-align: center;
            }
            div:last-child {
                color: #999;
                font-size: 14px;
            }
        }
    }
    .pay-tip {
        border: 1px solid #ffca85;
        display: flex;
        align-items: center;
        margin: 20px 0;
        padding: 20px 10px;
        img {
            width: 35px;
            margin-right: 10px;
        }
        div {
            color: #ffca85;
            font-size: 16px;
        }
    }

    .table-footer {
        border: 1px solid #ebeef5;
        padding: 15px 10px;
        align-items: center;
        border-top: none;
        display: flex;
        justify-content: space-between;
        div {
            font-size: 16px;
            color: #0089e5;
        }
        .f-footer {
            display: flex;
            align-items: center;
            div {
                color: #545b6d;
                margin: 0 10px;
                span {
                    color: #ff8d3c;
                }
            }
        }
    }
    .confirm-footer {
        display: block;
        overflow: hidden;
        padding-right: 30px;
        .f-footer {
            float: right;
            display: block;
            div {
                margin: 20px 0;
                span:first-child {
                    display: inline-block;
                    width: 200px;
                    color: #545b6d;
                    text-align: right;
                    margin-right: 20px;
                }
            }
            div:nth-child(2) {
                span:last-child {
                    font-weight: 700;
                    font-size: 20px;
                }
            }
        }
    }
    .remark {
        // position: absolute;
        // bottom:0px;
        border-top: 1px dashed #c9d0e1;
        width: 100%;
        font-size: 16px;
        padding-top: 8px;
    }
    .payMoney {
        font-size: 16px;
        color: #545b6d;
        text-align: center;
        span {
            font-size: 30px;
            color: #ff8d3c;
        }
    }
    .el-button--default {
        border-color: #ebeef5;
        color: #333;
    }
    .el-button {
        border-bottom: none;
        border-radius: 0;
    }
    .paytype {
        padding-bottom: 30px;
        margin-top: 30px;
        div.item-m {
            display: flex;
        }
        div {
            margin: 5px 0;
            padding: 0 15px;
            font-size: 16px;

            div.pay-item {
                border: 1px solid #dcdfe6;
                float: left;
                margin-right: 10px;
                height: 60px;
            }
            div.pay-item:hover {
                border: 1px solid #409eff;
                cursor: pointer;
            }
            div {
                display: flex;
                align-items: center;
                padding: 0px;
                img {
                    width: 50px;
                    margin-right: 6px;
                }
                div {
                    display: block;
                    margin: 0px;
                    padding: 0 0px;
                }
            }
            img.c-circle {
                float: right;
                height: 24px;
                width: 24px;
            }
        }
        .pay-title {
            margin-bottom: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pay/paynow.vue